export class inboundCampTransfer {
  constructor(inboundCampJson) {
    this.camdId = inboundCampJson.inbound_id;
    this.campName = inboundCampJson.name;
    this.frame = inboundCampJson.frame;
  }
}
export class agentTransfer {
  constructor(agentJson) {
    this.extensionId = agentJson.extid;
    this.agentName = agentJson.name;
    this.agentLogin = agentJson.login;
  }
}
export class numberTransfer {
  constructor(numberJson) {
    this.phoneId = numberJson.id;
    this.name = numberJson.name;
    this.phoneNumber = numberJson.number;
    this.idArea = numberJson.id_area;
    this.allowsConference = numberJson.allowsConference;
  }
}
